<div class="ranking-list-overlay-header">
  <brt-icon [icon]="'raking'" [add-blur]="true"></brt-icon> <span>Rangliste</span>
</div>
